
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"48","height":"48","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M24.875 13.125h12.75a1 1 0 011 1v18a1 1 0 01-1 1h-12.25m3.5-15.875H24.75m0 0v19.882a1 1 0 01-1.214.977L8.411 34.797a1 1 0 01-.786-.977V12.578a1 1 0 01.814-.982l15.125-2.87a1 1 0 011.186.982v7.542zm4.125 3.875H24.75m4.125 4.25H24.75m4.125 4.125H24.75","stroke":"#000C1F","stroke-width":"2","stroke-linecap":"round"}}),_c('path',{attrs:{"d":"M19.875 17.375l-7.75 11.375m0-10.563l7.75 11.438","stroke":"#56BFC7","stroke-width":"2","stroke-linecap":"round"}})])
          )
        }
      }
    